import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Home from './components/Home';
import Messages from './components/Messages';
import Plans from './components/Plans';
import Support from './components/Support';
import UserDetail from './components/UserDetail';
import BugReports from './components/BugReports';
import Layout from './components/Layout';
import { SupportNotificationsProvider } from './context/SupportNotificationsContext';
import { auth } from './services/firebase';
import { onAuthStateChanged } from 'firebase/auth';

const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = React.useState<boolean | null>(null);

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user: any) => {
      setIsAuthenticated(!!user);
    });

    return () => unsubscribe();
  }, []);

  if (isAuthenticated === null) {
    return (
      <div style={styles.loading}>
        <div>Carregando...</div>
      </div>
    );
  }

  return (
    <Router>
      <SupportNotificationsProvider enabled={isAuthenticated}>
      <Routes>
        <Route 
          path="/" 
          element={isAuthenticated ? <Navigate to="/home" /> : <Login />} 
        />
        <Route 
          path="/home" 
          element={isAuthenticated ? <Layout><Home /></Layout> : <Navigate to="/" />} 
        />
        <Route 
          path="/messages" 
          element={isAuthenticated ? <Layout><Messages /></Layout> : <Navigate to="/" />} 
        />
        <Route 
          path="/plans" 
          element={isAuthenticated ? <Layout><Plans /></Layout> : <Navigate to="/" />} 
        />
        <Route 
          path="/support" 
          element={isAuthenticated ? <Layout><Support /></Layout> : <Navigate to="/" />} 
        />
        <Route 
          path="/bug-reports" 
          element={isAuthenticated ? <Layout><BugReports /></Layout> : <Navigate to="/" />} 
        />
        <Route 
          path="/user/:id" 
          element={isAuthenticated ? <Layout><UserDetail /></Layout> : <Navigate to="/" />} 
        />
      </Routes>
      </SupportNotificationsProvider>
    </Router>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0D47A1 0%, #1976D2 50%, #42A5F5 100%)',
    color: '#FFFFFF',
    fontSize: '24px',
    fontWeight: 'bold',
  },
};

export default App;